import {
  aiAnalyzedFileSchema,
  AiAnalyzedFileSource,
} from "@redotech/redo-model/ai-analyzed-file";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const paginateAiAnalyzedFiles = {
  name: "paginateAiAnalyzedFiles" as const,
  input: z.object({
    source: createEnum(AiAnalyzedFileSource).optional(),
    limit: z.number().positive().optional(),
    lastId: zExt.objectId().optional(),
    searchText: z.string().optional(),
  }),
  output: z.object({
    data: z.array(aiAnalyzedFileSchema),
    paginationKey: z.string().optional(),
  }),
};
